// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1Yv6I","card":"Cards_card__2Bc-i","infected":"Cards_infected__3Ky9T","recovered":"Cards_recovered__2Xitw","deaths":"Cards_deaths__hOgrG"};